"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHasInvoice = void 0;
/**
 * Allows you to see if a job has an invoice or not
 */
var getHasInvoice = function (instance) { return function (id, config) {
    return instance.get("/jobs/has-invoice/".concat(id), config);
}; };
exports.getHasInvoice = getHasInvoice;
